export default __webpack_public_path__ + "static/media/gallery5.104fe3d2.jpg";